import React from 'react'
// routes
import { PATH_DOCS, PATH_PAGE } from '../../routes/paths'
// components
import { PATH_AFTER_LOGIN, siteData } from '../../config'
// components
import Iconify from '../../components/Iconify'
import { universalMenuConfig } from '../MenuConfig'

// ----------------------------------------------------------------------

const ICON_SIZE = {
	width: 22,
	height: 22,
}

const menuConfig = [
	...universalMenuConfig]

export default menuConfig
